import React from 'react'
import { HeadingPages } from '../../../components/HeadingPages'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'
import { Center, Flex, Icon, Spinner, TableContainer, Text, useToast } from '@chakra-ui/react'
import { Button } from '../../../components/Button'
import { FaFileExcel } from 'react-icons/fa'
import * as T from '../../../components/Table'
import { Pagination } from '../../../components/Pagination'
import { formatPrice } from '../../../utils/formatPrice'

async function uploadPlanilha({ planilha }) {
  const formData = new FormData()
  formData.append('planilha', planilha)

  const response = await api.post('/crm-interno/dados-luga', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export const UploadLuga = () => {
  const [paginatedData, setPaginatedData] = React.useState([])
  const [page, setPage] = React.useState(1)

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const {
    mutateAsync: uploadPlanilhaAsync,
    isLoading,
    error,
    data,
  } = useMutation({
    mutationFn: uploadPlanilha,
    onSuccess: (data) => {
      const { dados } = data

      const formattedData = dados.map((item) => ({
        codigo: item.codigo,
        preco: formatPrice(item.preco),
      }))

      const dataPaginated = formattedData.slice(0, 10)
      setPaginatedData(dataPaginated)

      toast({
        title: 'Planilha enviada com sucesso',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao enviar planilha',
        status: 'error',
      })
    },
  })

  const handleUploadPlanilha = async (event) => {
    const planilha = event.target.files[0]

    await uploadPlanilhaAsync({ planilha })
  }

  function handlePageChange(pageNumber) {
    if (pageNumber < 1 || pageNumber > Math.ceil(data?.dados?.length / 10)) {
      return
    }

    const start = (pageNumber - 1) * 10
    const end = pageNumber * 10

    const formattedData = data?.dados?.map((item) => ({
      codigo: item.codigo,
      preco: formatPrice(item.preco),
    }))

    const dataPaginated = formattedData.slice(start, end)
    setPaginatedData(dataPaginated)

    setPage(pageNumber)
  }

  return (
    <>
      <HeadingPages name="Upload de Luga" />

      <Flex gap={2} w="100%" maxW="600px" direction="column" alignItems="center" mt="10" justifyContent="center" mx="auto">
        <Button
          as="label"
          htmlFor="planilha"
          cursor="pointer"
          bgColor="green.500"
          size="sm"
          type="submit"
          px="30px"
          leftIcon={<Icon color="white" as={FaFileExcel} fontSize="lg" />}
        >
          Upload de planilha Luga
          <input onChange={handleUploadPlanilha} accept=".xls,.xlsx,.csv" id="planilha" type="file" style={{ display: 'none' }} />
        </Button>

        {isLoading && (
          <Center position="fixed" inset="0" bgColor="rgba(0, 0, 0, 0.5)" zIndex="9999" color="white" fontSize="2xl" fontWeight="bold">
            <Text>Enviando planilha...</Text>
            <Spinner size="lg" ml="2" />
          </Center>
        )}

        {error && <Text>Erro ao enviar planilha</Text>}

        <Flex justifyContent="space-between" alignItems="center" w="100%">
          {/* <Text color="green.500" fontWeight="bold" fontSize="sm">
            Planilha enviada com sucesso
          </Text> */}
          <Text color="gray.500" fontWeight="semibold" fontSize="sm">
            Quantidade de registros:{' '}
            <Text as="span" color="black" fontWeight={'bold'}>
              {data?.dados?.length}
            </Text>
          </Text>
        </Flex>
        {data && (
          <TableContainer w="100%" overflowX="auto" boxShadow="md" borderRadius="md" bgColor="white" p="4">
            <T.Table>
              <T.Thead>
                <T.Tr>
                  <T.Th>Código</T.Th>
                  <T.Th>Preço</T.Th>
                </T.Tr>
              </T.Thead>
              <T.Tbody>
                {paginatedData?.map((item, index) => (
                  <T.Tr key={index}>
                    <T.Td w="50%">{item.codigo}</T.Td>
                    <T.Td w="50%">{item.preco}</T.Td>
                  </T.Tr>
                ))}
              </T.Tbody>
            </T.Table>
          </TableContainer>
        )}

        {data && (
          <Pagination page={page} setPage={handlePageChange} limit={10} totalPages={Math.ceil(data?.dados?.length / 10)} isDisabled={isLoading} />
        )}
      </Flex>
    </>
  )
}
